// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"styles_thumbnail__UrYVM"};